import Module from '../utils/Module';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class TextImageModule extends Module {
  constructor (options) {
    super(options)

    this.DOMEl = options.element;
    this.contentTitle = this.DOMEl.querySelector(".title");
    this.contentParagraphs = this.DOMEl.querySelector(".paragraphs");
    this.contentImage = this.DOMEl.querySelector(".image-container");
    this.contentLink = this.DOMEl.querySelector(".link");
    if(this.contentLink!== null){
      this.contentLinkAnchor = this.contentLink.querySelector('a');
    }

    this.directionLayout = this.DOMEl.querySelector('.container').getAttribute("data-align");
    this.timeline = gsap.timeline().pause();

    this.init();
  }

  init () {

    switch (this.directionLayout) {
      case 'left':
        this.setupTimelineLeft();
        break;

      case 'right':
        this.setupTimelineRight();
        break;

      case 'center':
        this.setupTimelineCenter();
        break;
    }

    ScrollTrigger.create({
      trigger: this.DOMEl,
      start: "top center+=100",
      onEnter: ()=>{
        this.timeline.play();
      },
      onEnterBack: ()=>{
        this.timeline.play();
      }
    });

    if(this.contentLinkAnchor !== null && typeof(this.contentLinkAnchor) !== "undefined")
    {
      this.contentLinkAnchor.addEventListener('click', (event) => {
        event.stopPropagation();
        this.trackClick();
      });
    }
  }

  setupTimelineLeft (){
    this.timeline.to(this.contentImage, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"});
    if(this.contentTitle) this.timeline.to(this.contentTitle, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"}, '-=0.6');
    this.timeline.to(this.contentParagraphs, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"}, '-=0.6');
    if(this.contentLink) this.timeline.to(this.contentLink, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"}, '-=0.6');
  }

  setupTimelineRight (){
    if(this.contentTitle) this.timeline.to(this.contentTitle, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"});
    this.timeline.to(this.contentParagraphs, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"}, '-=0.6');
    if(this.contentLink) this.timeline.to(this.contentLink, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"}, '-=0.6');
    this.timeline.to(this.contentImage, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"}, '-=0.6');
  }

  setupTimelineCenter (){
    if(this.contentTitle) this.timeline.to(this.contentTitle, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"});
    this.timeline.to(this.contentParagraphs, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"}, '-=0.6');
    if(this.contentLink) this.timeline.to(this.contentLink, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"}, '-=0.6');
    this.timeline.to(this.contentImage, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"}, '-=0.6');
  }

  trackClick() {
    dataLayer.push({
      "event": "contentInteraction",
      "interaction": {
        "category": "content interaction",
        "action": this.contentLinkAnchor.textContent.toLowerCase(),
        "label": window.location.href
      }
    });
  }
}
